import Office from "reusableComponents/Icons/Office";
import Articles from "layouts/articles/Articles";
import References from "layouts/references/References";

const routes = [
  {
    type: "collapse",
    name: "Articles",
    key: "articles",
    route: "/articles",
    icon: <Office size="12px" />,
    component: <Articles />,
    noCollapse: true,
  },
   {
    type: "route",
    name: "References",
    key: "references",
    route: "/article/:id",
    component: <References />,
    noCollapse: true,
  },
 
];

export default routes;
